/* eslint-disable @typescript-eslint/no-explicit-any */
import { _createFetchClient } from './create-fetch-client'
import { _addErrorMiddleware, _addRequestMiddleware } from './middleware'
import { _createRefreshApi } from './refresh'
import { _defineRequest } from './tools'
import { _FetchConfigData } from './types'
import { _createUseFetch } from './use-fetch'

export function _createFetchInstance() {
  let isInitialized = false
  const cache: _FetchConfigData['cache'] = new Map<string, any>()
  const inflight: _FetchConfigData['inflight'] = new Map<string, Promise<any>>()
  const requestMiddlewares: _FetchConfigData['requestMiddlewares'] = []
  const errorMiddlewares: _FetchConfigData['errorMiddlewares'] = []
  const refreshMap: _FetchConfigData['refreshMap'] = new Map<
    string,
    Set<() => void>
  >()

  const fetchConfigData: _FetchConfigData = {
    cache,
    inflight,
    requestMiddlewares,
    errorMiddlewares,
    refreshMap
  }

  return {
    cache,
    inflight,
    requestMiddlewares,
    errorMiddlewares,
    isInitialized,

    init: (callback: () => void) => {
      if (isInitialized) return
      isInitialized = true
      callback()
    },

    defineRequest: _defineRequest,
    useFetch: _createUseFetch(fetchConfigData),
    createFetchClient: _createFetchClient(fetchConfigData),
    addRequestMiddleware: _addRequestMiddleware(fetchConfigData),
    addErrorMiddleware: _addErrorMiddleware(fetchConfigData),
    refreshApi: _createRefreshApi(fetchConfigData)
  }
}
